import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { BlockUIService } from 'ng-block-ui';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { CurrentUser } from 'src/app/core/models/currentUser.model';
import { ajaxCall, ajaxCallReturnValue } from 'src/app/core/services/ajax-call.service';
import { UploadResult } from '../upload-result.model';
import { DirtyTrackingDirective } from '../dirty-tracking/dirty-tracking.directive';
import { FocusMeDirective } from '../focus-me/focus-me.directive';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styles: [
  ]
})
export class MyProfileComponent implements OnInit {

  @ViewChild(NgForm) profileForm!: NgForm;

  profile: ProfileInformation = new ProfileInformation();
  submitAttempt: boolean = false;
  public uploader: FileUploader = new FileUploader({ url: '/File/Upload', autoUpload: true });

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal,
    private notifier: NotifierService,
    private blockUI: BlockUIService) { }

  ngOnInit(): void {
    this.ajax.MakeCall<ProfileInformation>('/User/Profile').then(data => {
      this.profile = data;
    }, () => { });

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      this.blockUI.start('ajaxCall');
    };

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      const file: ajaxCallReturnValue<UploadResult[]> = JSON.parse(response);
      if (file.success) {
        this.profile.avatar = file.results[0];
      } else {
        this.notifier.notify('error', file.message);
      }
      this.blockUI.stop('ajaxCall');
    };
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.profileForm.invalid) {
      return;
    }
    this.ajax.MakeCall<CurrentUser>('/User/SaveProfile', this.profile).then(data => {
      this.modal.close(data);
    }, () => { });
  }

  removeAvatar(): void {
    this.profile.avatar = null;
  }
}

export class ProfileInformation {
  firstName: string;
  lastName: string;
  emailAddress: string;
  avatar?: UploadResult;
}